import axios from 'axios';
import moment from 'moment-timezone';
import { getCurrentAccessToken } from '@/api/auth';
import { delay } from '@/helpers/promises';
import retryGet from './retryGet';

const TTL_SECONDS = 50;
const CACHE = {};

function getKey(overrides, params, trace) {
  const json = { overrides, params, trace };
  const string = JSON.stringify(json);
  return string;
}
function getCache(key) {
  const result = CACHE[key];
  if (typeof result !== 'object' || !result) return undefined;
  if (result.ttl < Date.now()) {
    delete CACHE[key];
    return undefined;
  }
  return result.data;
}
function setCache(key, data) {
  const ttl = Date.now() + (TTL_SECONDS * 1000);
  CACHE[key] = { ttl, data };
}

async function getUrl(overrides, params, attempt = 0) {
  const clientTimezone = moment.tz.guess();
  const Authorization = await getCurrentAccessToken();

  Object.entries(params).forEach(([k, v]) => {
    if (typeof v === 'object') {
      params[k] = JSON.stringify(v); // eslint-disable-line no-param-reassign
    }
  });

  const requestParams = {
    clientTimezone,
    ...params,
  };

  try {
    const { headers: { location: url } } = await axios({
      params: requestParams,
      headers: { Authorization },
      ...overrides,
    });
    return url;
  } catch (error) {
    if (attempt > 2) throw error; // genuinely unhandled
    await delay(1000); // mostly likely auth; let it rollover and try again
    return getUrl(overrides, params, attempt + 1);
  }
}

async function getter(overrides, params, trace) {
  const url = await getUrl(overrides, params);

  const { data, data: { error } = {} } = await retryGet(url, { ...trace, params });
  if (error) {
    const prettyError = JSON.stringify({ ...trace, params, error }, null, 2);
    throw new Error(`Telemetry result error: ${prettyError}`);
  }
  return data;
}

export default async function get(overrides, params, trace) {
  const key = getKey(overrides, params, trace);
  const cached = getCache(key);
  if (cached) {
    return cached;
  }
  const promise = getter(overrides, params, trace);
  setCache(key, promise);
  return promise;
}
